import { render, staticRenderFns } from "./receivableDetail.vue?vue&type=template&id=334d81b6"
import script from "./receivableDetail.vue?vue&type=script&lang=js"
export * from "./receivableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports